import { baseApi } from "@/services/api";

import { FilterOption } from "./types";

const apiWithTags = baseApi.enhanceEndpoints({});

interface GetFiltersQueryArgs {
  name: string;
  page?: number;
  params?: string;
}

export const filtersApi = apiWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getFilters: builder.query<{ items: FilterOption[] }, GetFiltersQueryArgs>({
      query: ({ name, page, params }) => {
        const searchParams = new URLSearchParams(params).toString();
        return `filters/${name}${
          searchParams ? `?${searchParams}&page=${page}` : `?page=${page}`
        }`;
      },
      providesTags: ["Filters"],
      transformResponse: (res: any, _, args) => {
        const { items } = res;
        return items.map((item: any) => ({
          value: item.id,
          label: item.name,
          type: args.name,
        }));
      },
    }),
  }),
});

export const { useGetFiltersQuery } = filtersApi;
